// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"bd374c2b","84":"12777d80","193":"a6c5e1a9","638":"b8b3a7a3","874":"9275c91d"}[chunkId] + ".chunk.css";
};